import { SovPermissions } from 'actions/ui/app'
import { defaultCurrencyCode } from 'configuration/currency'
import { AGGREGATION, DATES } from 'const/filters'
import { AGG_UNIT, FILTER_SETTINGS, FILTERS } from 'const/reducerKeys'
import {
    AppFiltersState,
    AsyncUpdate,
    AutomationCapability,
    BrandGroup,
    ChartColorsMap,
    CurrencyCode,
    CustomEvent,
    FilterSettings,
    GlobalNotification,
    Label,
    Report,
    TriggeredAlert,
} from 'types'

import { defaultDatesFilter } from '../defaults'

interface DrawerReportsState {
    isVisible: boolean
    loading: boolean
    error: string | null
    reports: Report[]
}

interface TriggeredAlertsState {
    loading: boolean
    error: string | null
    results: TriggeredAlert[]
}

interface RulebookDryRunState {
    loading: boolean
    error: string | null
    results: unknown[]
}

export interface AppState {
    mounting: boolean
    currencyCode: CurrencyCode
    globalNotification: GlobalNotification | null
    organizationLabels: Label[]
    automationCapabilities: AutomationCapability[]
    hiddenAutomationCapabilities: string[]
    brandGroups: BrandGroup[]
    customEvents: CustomEvent[]
    newReports: Report[]
    drawerReports: DrawerReportsState
    newUpdates: AsyncUpdate[]
    homeDashboardId: string | null
    triggeredAlerts: TriggeredAlertsState
    layout: {
        isSidebarCollapsed: boolean
    }
    userSurveyLastRead: string | null
    rulebookDryRun: RulebookDryRunState
    [FILTERS]: AppFiltersState
    [FILTER_SETTINGS]: FilterSettings
    chartColorsMap: ChartColorsMap
    sovPermissions?: SovPermissions
}

/**
 * Default state for the app reducer. Exported so AppState can be used by
 * reducer maps (e.g. brandGroups) without circular imports.
 */
export const defaultAppState: AppState = {
    mounting: true,
    currencyCode: defaultCurrencyCode,
    globalNotification: null,
    organizationLabels: [],
    automationCapabilities: [],
    hiddenAutomationCapabilities: [],
    brandGroups: [],
    customEvents: [],
    newReports: [],
    drawerReports: {
        isVisible: false,
        loading: false,
        error: null,
        reports: [],
    },
    newUpdates: [],
    homeDashboardId: null,
    triggeredAlerts: {
        loading: false,
        error: null,
        results: [],
    },
    layout: {
        isSidebarCollapsed: false,
    },
    userSurveyLastRead: null,
    rulebookDryRun: {
        loading: false,
        error: null,
        results: [],
    },
    [FILTERS]: {
        [AGGREGATION]: AGG_UNIT.DAY as AppFiltersState['aggregation'],
        [DATES]: defaultDatesFilter,
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [],
        displayState: {},
    },
    chartColorsMap: {},
}
